import React from 'react';
import Link from 'next/link';

const CourseCard = ({ course, courseNavbar, avgFee, numberOfColleges }: any) => {
  const courseLink =
    course?.page_data?.length > 0
      ? `/courses/${course?.course_url}/${courseNavbar?.replace(/\s+/g, '-')?.toLowerCase()}`
      : '#';

  const sanitizeFee = (fee: string) => {
    if (!fee) return 'N/A';
    return fee.replace(/per year/gi, '').trim();
  };

  return (
    <div className="my-2 w-full min-w-80 max-w-md rounded-xl border border-gray-200 bg-white shadow-sm transition hover:shadow-md xl:max-w-[21.2rem]">
      {/* Top Section */}
      <div className="flex items-center justify-between gap-x-4 px-4 pb-2 pt-3">
        <Link
          href={courseLink}
          className="line-clamp-1 text-base font-semibold capitalize tracking-tight text-black hover:underline"
        >
          {course?.abbreviation ?? course?.course_name ?? 'N/A'}
        </Link>

        <span className="rounded bg-gray-100 px-2 py-1 text-xxs font-medium text-gray-600 shadow-sm">
          {course?.courses_type?.course_type ?? 'N/A'}
        </span>
      </div>

      {/* Stats Section */}
      <div className="flex justify-between px-4 py-3 text-xs text-gray-500">
        {/* Duration */}
        <div className="flex w-1/3 flex-col items-center justify-center border-r border-gray-200 pr-4">
          <span>Duration</span>
          <span className="mt-1 text-[0.7rem] font-medium text-primary">
            {course?.course_duration?.duration ?? 'N/A'}
          </span>
        </div>

        {/* Avg. Fees */}
        <div className="flex w-1/3 flex-col items-center justify-center truncate border-r border-gray-200">
          <span>Avg. Fees</span>
          <span className="mt-1 truncate text-center text-[0.7rem] font-medium text-primary">
            {sanitizeFee(course?.average_fees?.average_fee)}
          </span>
        </div>

        {/* Total Colleges */}
        <div className="flex w-1/3 flex-col items-center justify-center pl-4">
          <span>Total Colleges</span>
          <span className="mt-1 text-[0.7rem] font-medium text-primary">{numberOfColleges ?? 'N/A'}</span>
        </div>
      </div>

      {/* Footer Link */}
      <Link
        href={courseLink}
        className="flex items-center justify-between border-t border-gray-200 px-4 py-2 text-sm text-blue-600 hover:underline"
      >
        <span>Know more</span>
        {/* Uncomment your icon here if needed */}
        {/* <ChevrondownSvg className="-rotate-90 text-gray-400" /> */}
      </Link>
    </div>
  );
};

export default CourseCard;
